import { GET_TEMPLATE_BRANCH_AND_COMPANY, GET_TEMPLATE_SERVICE_ITEM, UPDATE_TEMPLATE_BRANCH_AND_COMPANY } from "../../types/template"

// ** Initial State
const initialState = {
  isLoading: false,
  isPageLoading: false,
  workflowTemplateList: [],
  workflowTemplateListForSelection: [],
  workflowCategoryList: [],
  workflowTemplateDetail: {},
  workflowEmailTemplate: [],
  workflowEmailTemplateDetail: {},
  updateOrAddedTemplate: {},
  templateServiceItem: [],
  templateBranchAndCompanyItem: [],
  templateReportType: [],
  workflowTemplateDetailInternalTag: {},
  selectedTemplateService: {}
}

const workFlowTemplateReducer = (state = initialState, action) => {
  switch (action.type) {
    case "PAGE_LOADING":
      return { ...state, isPageLoading: action.payload }
    case "GET_WORK_FLOW_TEMPLATE_DATA":
      return { ...state, workflowTemplateList: action.payload }
    case "GET_WORK_FLOW_TEMPLATE_DATA_FOR_SELECTION":
      return { ...state, workflowTemplateListForSelection: action.payload }
    case "GET_WORK_FLOW_TEMPLATE_CATEGORY":
      return { ...state, workflowCategoryList: action.payload }
    case "ADD_WORK_FLOW_TEMPLATE_DATA":
      return {
        ...state,
        workflowTemplateList: [...state.workflowTemplateList, action.payload]
      }
    case "GET_TEMPLATE_DATA_BY_ID":
      return {
        ...state,
        workflowTemplateDetail: action.payload
      }
    case "RESET_TEMPLATE":
      return {
        ...state,
        workflowTemplateDetail: {}
      }
    case "SET_TEMPLATE_DATA_BY_ID_INTERNAL_TAG":
      return {
        ...state,
        workflowTemplateDetailInternalTag: action.payload
      }
    case "GET_EMAIL_TEMPLATE_LIST":
      return {
        ...state,
        workflowEmailTemplate: action.payload
      }
    case "GET_REPORT_TYPE_LIST_BY_TYPE":
      return {
        ...state,
        templateReportType: action.payload
      }
    case "GET_EMAIL_TEMPLATE_DETAIL":
      return {
        ...state,
        workflowEmailTemplateDetail: action.payload
      }
    case "EDIT_TEMPLATE_FLOW_DATA":
      return {
        ...state,
        workflowEmailTemplateDetail: action.payload
      }
    case "DELETE_WORK_TEMPLATE_DATA":
      return {
        ...state,
        workflowTemplateList: state.workflowTemplateList.filter((x) => { return !action.payload.includes(x._id) ? x : false })
      }
    case "ADD_EDIT_TEMPLATE":
      return {
        ...state,
        updateOrAddedTemplate: action.payload
      }
    case "RESET_TEMPLATE_DETAILS":
      return {
        ...state,
        workflowTemplateDetail: {},
        workflowEmailTemplate: [],
        workflowEmailTemplateDetail: {},
      }
    case GET_TEMPLATE_SERVICE_ITEM: {
      return {
        ...state,
        templateServiceItem: action.payload
      }
    }
    case GET_TEMPLATE_BRANCH_AND_COMPANY: {
      return {
        ...state,
        templateBranchAndCompanyItem: action.payload
      }
    }
    case "UPDATE_TEMPLATE_TITLE":
      return {
        ...state,
        workflowTemplateDetail: { ...state.workflowTemplateDetail, title: action.payload }
      }
    case "UPDATE_TEMPLATE_SERVICE":
      return {
        ...state,
        selectedTemplateService: action.payload
      }
    default:
      return state
  }
}

export default workFlowTemplateReducer
